module.exports = __webpack_public_path__ + "static/media/contact-computer.f1105b13.svg";